//#region src/paytronix_gift_auth_source.ts
let PaytronixGiftAuthSource = /* @__PURE__ */ function(PaytronixGiftAuthSource) {
	PaytronixGiftAuthSource["Direct"] = "direct";
	PaytronixGiftAuthSource["Olo"] = "olo";
	return PaytronixGiftAuthSource;
}({});
//#endregion
export { PaytronixGiftAuthSource };

//# sourceMappingURL=paytronix_gift_auth_source.js.map